import { OccupanciesApi, StackInRequest } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class OccupancyService {
  private readonly httpClient = createApiClient(OccupanciesApi)

  async getOccupancies() {
    const { data } = await this.httpClient.getOccupancies()

    return data
  }

  async stackIn(stackInRequest: StackInRequest) {
    await this.httpClient.stackIn(stackInRequest)
  }

  async getCurrentPosition(journeyId: number) {
    const { data } = await this.httpClient.currentPosition(journeyId)

    return data
  }

  async openJourneyPositions(journeyId?: number) {
    const { data } = await this.httpClient.openJourneyPositions(journeyId)

    return data
  }
}

export const occupancyService = new OccupancyService()
